import { CustomTooltip } from '@tcweb/connect-ui';
import { Component, JSX, Show } from 'solid-js';
import { IconType } from './constants';

export interface TreeActionProps {
  disabled?: boolean;
  icon: IconType;
  label: string;
  class?: string;
  onClick?(): void;
}

export const TreeAction: Component<TreeActionProps> = (
  props: TreeActionProps
): JSX.Element => {
  return (
    <CustomTooltip
      text={props.label}
      position={'bottom-start'}
      disableToolTip={props.disabled}
    >
      <div class={props.class}>
        <Show when={props.disabled}>
          <div
            data-testid="tree-action"
            class="flex w-10 h-10 rounded-full items-center justify-center"
          >
            <i
              data-testid="tree-action-icon-disabled"
              class={['icon-font', 'h-5 w-5 text-[1.25rem]', props.icon].join(
                ' '
              )}
            />
          </div>
        </Show>
        <Show when={!props.disabled}>
          <button
            class="w-10 h-10 rounded-full hover:bg-base-100 items-center"
            data-testid="tree-action"
            onClick={(event): void => {
              if (props.onClick) {
                event.stopPropagation(); // Prevent expand/collapse on action click
                props.onClick();
              }
            }}
          >
            <i
              data-testid="tree-action-icon"
              class={['icon-font', 'md', props.icon].join(' ')}
            />
          </button>
        </Show>
      </div>
    </CustomTooltip>
  );
};

export default TreeAction;
